
import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import About from "./pages/About";
import History from "./pages/History";
import FAQ from "./pages/FAQ";
import Recipe from "./pages/Recipe";
import CreateFortune from "./pages/CreateFortune";
import ViewFortune from "./pages/ViewFortune";
import NotFound from "./pages/NotFound";
import GlobalAdUnit from "./components/GlobalAdUnit";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <div className="relative">
            {/* Global ad unit that appears on all pages */}
            <div className="fixed bottom-0 left-0 w-full z-40 bg-white shadow-md">
              <div className="max-w-screen-lg mx-auto">
                <GlobalAdUnit />
              </div>
            </div>
            
            {/* Add padding at the bottom to prevent content from being hidden behind the ad */}
            <div className="pb-32">
              <Routes>
                <Route path="/" element={<About />} />
                <Route path="/fortune" element={<Index />} />
                <Route path="/about" element={<Navigate to="/" replace />} />
                <Route path="/history" element={<History />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/recipe" element={<Recipe />} />
                <Route path="/create-fortune" element={<CreateFortune />} />
                <Route path="/view-fortune" element={<ViewFortune />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </div>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
